// extracted by mini-css-extract-plugin
export default {"root":"NoShowPolicyNotice_root__++KFV","link":"NoShowPolicyNotice_link__CAHBy"};